import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { getOrder } from '../ordersThunk';
import { Order, OrdersState } from '../types';
import { CustomError } from 'shared/api';

export const getOrderReducer = (builder: ActionReducerMapBuilder<OrdersState>) => {
	builder
		.addCase(getOrder.pending, (state, action) => {
			// state.loadingDetail = true;
			state.selectedOrderId = action.meta.arg.id;
		})
		.addCase(
			getOrder.fulfilled,
			(state, action: PayloadAction<Order>) => {
				state.loadingDetail = false;
				state.orderDetail = action.payload;
				state.orderDetailPerson = action.payload.person;
				state.error = null;
			},
		)
		.addCase(
			getOrder.rejected,
			(state, action: PayloadAction<CustomError | undefined>) => {
				state.loadingDetail = false;
				if (action.payload) {
					state.error = action.payload;
				}
			},
		)
};